import { Routes } from '@angular/router';
import { posAuthGuard } from './guards/pos-auth.guard';
import { posRedirectIfAuthenticated } from './guards/redirect-if-authenticated.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [posRedirectIfAuthenticated],
  },
  {
    path: 'pos',
    loadComponent: () => import('./pages/pos/pos.page').then((m) => m.POSPage),
    canActivate: [posAuthGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'pos',
  },
  {
    path: '**',
    redirectTo: 'pos',
  },
];
